var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 62,
    viewBox: "0 0 46 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 58.2041H22.9247L14.4266 48.6708L22.9247 21.3235L27.2339 34.9972L31.5432 48.6708L22.9247 58.2041H42L28.3188 14.2041H17.6812L4 58.2041Z",
    fill: "#FBD15B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.252058 20.8468C0.187747 25.8492 1.3873 30.0407 3.8507 33.4213C6.33406 36.8224 9.69955 39.226 13.9472 40.6323L16.0731 33.3061C13.2542 32.4225 11.0492 30.9517 9.45837 28.8937C7.8675 26.8356 7.09294 24.1828 7.13469 20.9353C7.19096 16.5581 8.67861 13.2788 11.5976 11.0971C14.5366 8.93589 18.3913 7.88595 23.1616 7.94727C27.9317 8.02877 31.7479 9.18742 34.6101 11.4232C37.4925 13.6593 38.9056 16.9659 38.8494 21.343C38.8076 24.5905 37.9651 27.2225 36.3219 29.239C34.6786 31.2555 32.8204 32.4953 29.9796 33.3061L32.7366 40.6322C37.0392 39.3358 39.2615 37.2457 41.8113 33.9093C44.3608 30.5932 45.6677 26.4339 45.732 21.4315C45.7877 17.0947 44.8756 13.3507 42.9955 10.1995C41.1354 7.06876 38.5081 4.64432 35.1136 2.92621C31.739 1.22852 27.7878 0.35058 23.26 0.29237C18.7525 0.234421 14.78 1.0105 11.3427 2.62061C7.90514 4.25088 5.20625 6.60685 3.24606 9.6885C1.30581 12.7906 0.307812 16.51 0.252058 20.8468Z",
    fill: "#FBD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.19be456fae8d9495ef3b64ca6797ce6d.svg";
export { ForwardRef as ReactComponent };